module.exports = __webpack_public_path__ + "img/isamilo_lodge_gallery_32.21447f8c.jpeg";